import React, { useCallback } from 'react';
import { useToggle } from 'Shared/utils/hooks';

import WpButton from 'Wpds/components/button/WpButton';
import { WpDropdown, WpDropdownToggle, WpDropdownMenu, WpDropdownMenuItem } from 'Wpds/components/dropdown';

import ExportGoalsModal from './ExportGoalsModal/ExportGoalsModal';
import WpIcon from 'Wpds/components/icon/WpIcon';

function ExportGoalsButton({ disabled }: { disabled?: boolean }) {
  const [isOpen, toggleIsOpen] = useToggle(false);

  const handleModalToggle = useCallback(() => toggleIsOpen(), [toggleIsOpen]);

  return (
    <>
      <WpDropdown placement="bottom-end">
        <WpDropdownToggle>
          <WpButton variant="tertiary">
            <WpIcon name="ellipsis-h-alt" />
          </WpButton>
        </WpDropdownToggle>
        <WpDropdownMenu>
          <WpDropdownMenuItem disabled={disabled} onClick={handleModalToggle}>
            <WpIcon name="file-export" /> Export Goals
          </WpDropdownMenuItem>
        </WpDropdownMenu>
      </WpDropdown>
      {isOpen && <ExportGoalsModal onToggle={handleModalToggle} />}
    </>
  );
}

export default ExportGoalsButton;
